/* eslint-disable @typescript-eslint/no-empty-function */
import React, { ReactElement, useMemo } from 'react';
import { render as renderDom } from 'react-dom';
import { App } from './App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ActionItem } from './types/FpuActionItem';
import { AutoFillableFields } from './types/autoFillableFields';
import { useSegmentInitialize } from './hooks';

interface CoverageCheckupProps {
  completeFpuActionItem: Function;
  actionItem: ActionItem | {}; // TODO make this optional
  autoFillableFields?: AutoFillableFields;
  segmentApiKey?: string;
}

export function render(
  rootContainer: HTMLElement,
  {
    completeFpuActionItem = () => {},
    actionItem = {},
    autoFillableFields,
    segmentApiKey = '',
  }: CoverageCheckupProps
): void {
  renderDom(
    <CoverageCheckup
      completeFpuActionItem={completeFpuActionItem}
      actionItem={actionItem}
      autoFillableFields={autoFillableFields}
      segmentApiKey={segmentApiKey}
    />,
    rootContainer
  );
}

export function CoverageCheckup({
  completeFpuActionItem = () => {},
  actionItem,
  autoFillableFields,
  segmentApiKey = '',
}: CoverageCheckupProps): ReactElement {
  useSegmentInitialize(segmentApiKey);

  return (
    <React.StrictMode>
      <Provider store={store}>
        <App
          completeFpuActionItem={completeFpuActionItem}
          actionItem={actionItem}
          autoFillableFields={autoFillableFields}
        />
      </Provider>
    </React.StrictMode>
  );
}
